import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment';

/** Shown when the user has no Fixed Assets access to what they asked for (FAM-156). */
@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: false,
})
export class UnauthorizedComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  goBack() {
    // Set when they still have access elsewhere, so send them back there.
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    if (returnUrl) {
      this.router.navigateByUrl(returnUrl);
      return;
    }

    // No access at all, so out to LeaseQuery. Per environment, not the prod host.
    const base = (environment.lqmsWebApp ?? '').replace(/\/+$/, '');
    window.location.href = base ? `${base}/Dashboard` : '/';
  }
}
